/* -------------------------------------------------------------------------- */
/*                                   Roles                                    */
/* -------------------------------------------------------------------------- */
import { FRONT_ACLS_ADMIN } from '@config/constants/acls-per-roles/admin';
import { FRONT_ACLS_ALL } from '@config/constants/acls-per-roles/all';
import { FRONT_ACLS_BRAND_ADMIN } from '@config/constants/acls-per-roles/brand-admin';
import { FRONT_ACLS_BRAND_STAFF } from '@config/constants/acls-per-roles/brand-staff';
import { FRONT_ACLS_ORGANIZATION_ADMIN } from '@config/constants/acls-per-roles/organization-admin';
import { FRONT_ACLS_ORGANIZATION_MEMBER } from '@config/constants/acls-per-roles/organization-member';
import { FRONT_ACLS_ORGANIZATION_STAFF } from '@config/constants/acls-per-roles/organization-staff';
import { FRONT_ACLS_PRODUCER_ADMIN } from '@config/constants/acls-per-roles/producer-admin';
import { FRONT_ACLS_PRODUCER_STAFF } from '@config/constants/acls-per-roles/producer-staff';
import { FRONT_ACLS_STAFF } from '@config/constants/acls-per-roles/staff';
import { FRONT_ACLS_SUPERADMIN } from '@config/constants/acls-per-roles/superadmin';
import { FRONT_ACLS_USER } from '@config/constants/acls-per-roles/user';
import { ROLES } from '@config/constants/roles';

/* -------------------------------------------------------------------------- */
/*                                 ACLS_ALL                                  */
/* -------------------------------------------------------------------------- */

export const ACLS_ALL = {
	[ROLES.USER]: { FRONT: FRONT_ACLS_USER },
	[ROLES.ADMIN]: { FRONT: FRONT_ACLS_ADMIN },
	[ROLES.SUPERADMIN]: { FRONT: FRONT_ACLS_SUPERADMIN },
	[ROLES.STAFF]: { FRONT: FRONT_ACLS_STAFF },
	[ROLES.ORGANIZATION_ADMIN]: {
		FRONT: FRONT_ACLS_ORGANIZATION_ADMIN,
	},
	[ROLES.ORGANIZATION_STAFF]: {
		FRONT: FRONT_ACLS_ORGANIZATION_STAFF,
	},
	[ROLES.ORGANIZATION_MEMBER]: {
		FRONT: FRONT_ACLS_ORGANIZATION_MEMBER,
	},
	[ROLES.BRAND_ADMIN]: { FRONT: FRONT_ACLS_BRAND_ADMIN },
	[ROLES.BRAND_STAFF]: { FRONT: FRONT_ACLS_BRAND_STAFF },
	[ROLES.PRODUCER_ADMIN]: {
		FRONT: FRONT_ACLS_PRODUCER_ADMIN,
	},
	[ROLES.PRODUCER_STAFF]: {
		FRONT: FRONT_ACLS_PRODUCER_STAFF,
	},
	[ROLES.CLIENT_BRAND]: { FRONT: FRONT_ACLS_ADMIN },
	[ROLES.ANONYMOUS]: { FRONT: FRONT_ACLS_ADMIN },
} as const;

/* -------------------------------------------------------------------------- */
/*                          Type utilitaire pour ACLs                         */
/* -------------------------------------------------------------------------- */

type DeepValueOf<T> = T extends object
	? DeepValueOf<T[keyof T]>
	: T;
type AllAclValues = DeepValueOf<typeof FRONT_ACLS_ALL>;

/* -------------------------------------------------------------------------- */
/*                                 checkAclFront                              */
/* -------------------------------------------------------------------------- */

export function checkAclFront(
	aclValue: AllAclValues,
	role: ROLES
): boolean {
	const front = ACLS_ALL[role]?.FRONT;
	if (!front) return false;

	for (const section of Object.values(front)) {
		if (Object.values(section).includes(aclValue)) {
			return true;
		}
	}

	return false;
}

/* -------------------------------------------------------------------------- */
/*                               Usage Example                                */
/* -------------------------------------------------------------------------- */

// ✅ OK
// checkAclFront('dashboard:front:kpi_financing_of_additionality', ROLES.ADMIN);

// ✅ OK
// checkAclFront('dashboard:front:last_news', ROLES.USER);

// ❌ TS error — "dashboard:front:unknown" n’existe pas
// checkAclFront('dashboard:front:unknown', ROLES.ADMIN);
